import React, { useEffect, useRef } from 'react'
import { Provider } from 'react-redux'
import DigitalMenuRoutes from '../routes/DigitalMenuRoutes'
import { store } from '../stores/store'
import { createMuiTheme } from '@material-ui/core'
import ThemeProvider from '@material-ui/styles/ThemeProvider'
import theme from '../assets/theme'

const muiTheme = createMuiTheme(theme)

const DigitalMenu = () => {

  const scrollInto = useRef(null)

  useEffect(() => {
    if(scrollInto && scrollInto.current) {
      scrollInto.current.scrollIntoView()
    }
  })

  return <Provider store={store}>
    <ThemeProvider theme={muiTheme}>
      <DigitalMenuRoutes/>
    </ThemeProvider>
  </Provider>
}

export default DigitalMenu
